function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1886 35.5502C12.1886 35.1821 12.487 34.8837 12.8551 34.8837H23.4335C23.8016 34.8837 24.1 35.1821 24.1 35.5502C24.1 35.9183 23.8016 36.2167 23.4335 36.2167H12.8551C12.487 36.2167 12.1886 35.9183 12.1886 35.5502Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85518 35.5502C4.85518 35.1821 5.15358 34.8837 5.52167 34.8837H8.7667C9.1348 34.8837 9.43319 35.1821 9.43319 35.5502C9.43319 35.9183 9.1348 36.2167 8.7667 36.2167H5.52167C5.15358 36.2167 4.85518 35.9183 4.85518 35.5502Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88975 12.417C9.88975 12.0489 10.1881 11.7505 10.5562 11.7505H19.2867C19.6548 11.7505 19.9532 12.0489 19.9532 12.417C19.9532 12.7851 19.6548 13.0835 19.2867 13.0835H10.5562C10.1881 13.0835 9.88975 12.7851 9.88975 12.417Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2569 15.3577C14.2569 14.9896 14.5553 14.6912 14.9234 14.6912H19.2867C19.6548 14.6912 19.9532 14.9896 19.9532 15.3577C19.9532 15.7258 19.6548 16.0242 19.2867 16.0242H14.9234C14.5553 16.0242 14.2569 15.7258 14.2569 15.3577Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7664 8.66671C27.1345 8.66671 27.4329 8.96511 27.4329 9.3332V18.918C27.4329 19.2861 27.1345 19.5845 26.7664 19.5845C26.3983 19.5845 26.0999 19.2861 26.0999 18.918V9.3332C26.0999 8.96511 26.3983 8.66671 26.7664 8.66671Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6175 18.5381C21.9184 18.7502 21.9904 19.166 21.7783 19.4669C19.4814 22.7261 18.3539 26.8943 18.519 32.0344C18.5308 32.4023 18.2422 32.7101 17.8742 32.7219C17.5063 32.7337 17.1985 32.4451 17.1867 32.0772C17.0145 26.7158 18.1896 22.2452 20.6888 18.699C20.9008 18.3981 21.3166 18.3261 21.6175 18.5381Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0003 18.4309C25.3625 18.4965 25.6029 18.8433 25.5373 19.2055L24.9653 22.3626L24.965 22.364C24.7941 23.2962 23.9825 23.9846 23.0261 23.9846H22.8025C22.4344 23.9846 22.136 23.6862 22.136 23.3181C22.136 22.95 22.4344 22.6516 22.8025 22.6516H23.0261C23.331 22.6516 23.5973 22.4309 23.6538 22.1241C23.6538 22.1243 23.6539 22.1239 23.6538 22.1241L24.2257 18.9679C24.2913 18.6057 24.6381 18.3653 25.0003 18.4309Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4249 8.83545C32.4018 8.83303 32.3783 8.83179 32.3546 8.83179C31.9865 8.83179 31.6881 9.13018 31.6881 9.49828V14.4373C31.6881 14.8054 31.9865 15.1038 32.3546 15.1038H35.7792C36.822 15.1038 37.6668 14.2591 37.6668 13.2163V10.723C37.6668 9.68019 36.822 8.83545 35.7792 8.83545H32.4249ZM33.021 10.1684V13.7708H35.7792C36.0858 13.7708 36.3338 13.5229 36.3338 13.2163V10.723C36.3338 10.4164 36.0858 10.1684 35.7792 10.1684H33.021Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3338 11.9733C36.3338 11.6052 36.6322 11.3068 37.0002 11.3068H42.6617C43.0297 11.3068 43.3281 11.6052 43.3281 11.9733C43.3281 12.3414 43.0297 12.6398 42.6617 12.6398H37.0002C36.6322 12.6398 36.3338 12.3414 36.3338 11.9733Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57603 32.7222C7.25724 32.7222 6.18816 33.7913 6.18816 35.1101V39.2791C6.18816 40.5979 7.25724 41.667 8.57603 41.667H20.5882C21.907 41.667 22.9761 40.5979 22.9761 39.2791V35.1101C22.9761 33.7913 21.907 32.7222 20.5882 32.7222H8.57603ZM4.85518 35.1101C4.85518 33.0551 6.52105 31.3892 8.57603 31.3892H20.5882C22.6432 31.3892 24.309 33.0551 24.309 35.1101V39.2791C24.309 41.3341 22.6432 43 20.5882 43H8.57603C6.52105 43 4.85518 41.3341 4.85518 39.2791V35.1101Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67184 6.97184C4.67184 5.88141 5.55325 5 6.64368 5H26.6273C27.0435 5 27.4582 5.07769 27.8478 5.23523C27.8482 5.23538 27.8486 5.23554 27.849 5.23569L30.9587 6.48104C32.2064 6.97827 33.0212 8.18462 33.0212 9.52387V14.4739C33.0212 15.6245 32.4182 16.6922 31.4289 17.2858L28.0961 19.2877C27.5884 19.5923 27.0038 19.7531 26.4109 19.7531H9.55505C8.68497 19.7531 7.85185 19.4077 7.23574 18.7916L5.63339 17.1892C5.01727 16.5731 4.67184 15.74 4.67184 14.8699V6.97184ZM6.64368 6.33298C6.28944 6.33298 6.00483 6.61759 6.00483 6.97184V14.8699C6.00483 15.3859 6.20938 15.8801 6.57595 16.2467L8.1783 17.849C8.54487 18.2156 9.03912 18.4202 9.55505 18.4202H26.4109C26.7641 18.4202 27.1111 18.3242 27.41 18.1448L30.7428 16.143C31.3301 15.7905 31.6882 15.1568 31.6882 14.4739V9.52387C31.6882 8.7291 31.2049 8.01409 30.4652 7.71931L27.3511 6.47221L27.3489 6.4713C27.1228 6.37981 26.878 6.33298 26.6273 6.33298H6.64368Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1788 18.449C11.5289 18.3353 11.9049 18.527 12.0185 18.8771C12.4747 20.2821 12.5137 21.4351 12.328 22.4814C12.163 23.4113 11.8203 24.2424 11.4971 25.0263C11.4654 25.1031 11.4339 25.1795 11.4028 25.2555C11.0474 26.1231 10.7203 26.9794 10.5785 28.0144C10.4376 29.0429 10.4762 30.2795 10.9031 31.8845C10.9977 32.2402 10.786 32.6053 10.4302 32.6999C10.0745 32.7945 9.70945 32.5828 9.61484 32.2271C9.14699 30.4678 9.09077 29.0529 9.25785 27.8335C9.42404 26.6206 9.80786 25.6325 10.1693 24.7502C10.199 24.6778 10.2284 24.6063 10.2574 24.5356C10.5891 23.7293 10.877 23.0294 11.0155 22.2485C11.1617 21.4246 11.1416 20.4927 10.7507 19.2887C10.637 18.9386 10.8287 18.5627 11.1788 18.449Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplacing);
export default __webpack_public_path__ + "static/media/Replacing.1ac7c18f99e8c314804c5e373643f0c1.svg";
export { ForwardRef as ReactComponent };